"use client";

import { c as _c } from "react/compiler-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../../../../shared/utils/cn.js";
import { motion } from "motion/react";
import { useMemo } from "react";
export function TextShimmer(t0) {
  const $ = _c(6);
  const {
    children,
    as: t1,
    className,
    duration: t2,
    spread: t3
  } = t0;
  const Component = t1 === undefined ? "p" : t1;
  const duration = t2 === undefined ? 2 : t2;
  const spread = t3 === undefined ? 2 : t3;
  let t4;
  if ($[0] !== Component || $[1] !== children || $[2] !== className || $[3] !== duration || $[4] !== spread) {
    const MotionComponent = motion.create(Component);
    let t5;
    t5 = children.length * spread;
    const dynamicSpread = t5;
    t4 = _jsx(MotionComponent, {
      className: cn("relative inline-block bg-[length:250%_100%,auto] bg-clip-text", "text-transparent [--base-color:#a1a1aa] [--base-gradient-color:#000]", "[--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--base-gradient-color),#0000_calc(50%+var(--spread)))] [background-repeat:no-repeat,padding-box]", "dark:[--base-color:#71717a] dark:[--base-gradient-color:#ffffff] dark:[--bg:linear-gradient(90deg,#0000_calc(50%-var(--spread)),var(--base-gradient-color),#0000_calc(50%+var(--spread)))]", className),
      initial: {
        backgroundPosition: "100% center"
      },
      animate: {
        backgroundPosition: "0% center"
      },
      transition: {
        repeat: Infinity,
        duration,
        ease: "linear"
      },
      style: {
        "--spread": `${dynamicSpread}px`,
        backgroundImage: `var(--bg), linear-gradient(var(--base-color), var(--base-color))`
      },
      children
    });
    $[0] = Component;
    $[1] = children;
    $[2] = className;
    $[3] = duration;
    $[4] = spread;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}